export default class AnalyticsProvider {}

AnalyticsProvider.GoogleAnalytics = 'GOOGLE_ANALYTICS';
AnalyticsProvider.FullStory = 'FULLSTORY';
AnalyticsProvider.Statsig = 'STATSIG';
